import menu from './menu'
import configuracao from './configuracao'
import loader from './loader'
import publico from './portal/publico'
import auth from './auth'
import seguranca from './portal/seguranca'
import dialog from './dialog'
import arrecadacao from './arrecadacao'
import userInterface from './userInterface'
import central from './centralInteressado'
import financeiro from './financeiro'
import assinatura from './assinatura'
import demandas from './demandas'
import notificacoes from './notificacoes'
import relatorios from './relatorios'
import relatoriosReurb from './relatorios_reurb'
import analise from './analise'
import produtividade from './produtividade'
import credenciado from './credenciado'
import relatoriosOuvidoria from './relatorios_ouvidoria'
import notifications from './notifications'
import planilha from './planilha'
import diagnostico from './diagnostico'
import fila from './fila'
import gestaoDocumentos from './gestaoDocumentos'
import filtroPesquisaGeral from './filtroPesquisaGeral'
import processamentoPlanta from './processamentoPlanta'

const modules = {
  ...publico,
  ...arrecadacao,
  ...financeiro,
  ...central,
  ...analise,
  ...assinatura,
  ...seguranca,
  ...demandas,
  ...relatorios,
  ...produtividade,
  ...credenciado,
  ...relatoriosReurb,
  ...relatoriosOuvidoria,
  ...notifications,
  ...diagnostico,
  ...planilha,
  ...fila,
  ...gestaoDocumentos,
  filtroPesquisaGeral,
  processamentoPlanta,
  loader,
  auth,
  dialog,
  menu,
  configuracao,
  userInterface,
  notificacoes
}

export default modules



// WEBPACK FOOTER //
// ./src/store/modules/index.js